export const IndicatorArea = (props: { currentPhase: number, allStep: number }) => {
  const { currentPhase, allStep } = props;
  // currentPhaseの整数部分を取得
  const currentPhaseInt = Math.floor(currentPhase);

  return (
    <div className="m-form-flow">
      <ol className="m-form-flow-list" data-flow={allStep} data-progress={currentPhase}>
        {Array.from({ length: allStep }, (_, index) => {
          const stepNumber = index + 1;
          let className = '';

          if (stepNumber < currentPhaseInt || currentPhaseInt === allStep) {
            className = 'completed';
          } else if (stepNumber === currentPhaseInt) {
            className = 'current';
          }

          return (
            <li key={stepNumber} className={className}></li>
          );
        })}
      </ol>
    </div>
  );
};
